module.exports = __webpack_public_path__ + "img/plane.c07a062f.gif";